import React from "react";
var __jsx = React.createElement;
/**
 * Simple conditional component - renders children if condition is true
 * @example
 * <If condition={isLoggedIn}>
 *   <WelcomeMessage />
 * </If>
 */
export var If = function If(_ref) {
  var condition = _ref.condition,
    children = _ref.children;
  return condition ? /*#__PURE__*/React.createElement(React.Fragment, null, children) : null;
};